// @core/api/endpoints/authn/sign_up.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SignUpRequest,
  SignUpResponse,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Register a new user
 * Creates a new user account with email, username, and password. Returns access and refresh tokens on success. Supports referral codes for tracking user acquisition.
 * @public This endpoint does not require authentication
 */
export async function SignUp(
  data: SignUpRequest,
  options?: RequestOptions
): Promise<SignUpResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/auth/signup`;
  const requestOptions = { ...options, skipAuth: true };
  return client.post<SignUpResponse>(requestPath, data, requestOptions);
}
